import type {TZoneKind} from '../types/protectionZone.types'

export const ZONE_KINDS: readonly TZoneKind[] = ['all', 'simple', 'group']

export const DEFAULT_ZONE_KIND: TZoneKind = 'simple'

/** 'all' returns the input itself so memoised consumers keep their reference. */
export const filterSegmentsByZoneKind = <T extends {isGroup: boolean}>(
  items: T[],
  kind: TZoneKind,
): T[] => {
  if (kind === 'all') return items
  return items.filter(item => item.isGroup === (kind === 'group'))
}

/** Same filter for zones read from the list, where membership says what a group is. */
export const filterZonesByZoneKind = <T extends {memberIds: string[]}>(
  zones: T[],
  kind: TZoneKind,
): T[] => {
  if (kind === 'all') return zones
  return zones.filter(zone => zone.memberIds.length > 0 === (kind === 'group'))
}
